<template>
  <app-page-gradient-background class="overflow-x-hidden">
    <enterprise-page-hero />

    <app-page-wrapper
      class="flex flex-col gap-16 md:gap-24"
      :class="{ 'mt-16': !newHomeEnabled }"
    >
      <brand-logos-carousel
        :items="[
          'akur8',
          'pennylane',
          'loreal',
          'doctolib',
          'carrefour',
          'docaposte',
          'morning',
          'orange',
          'malt',
          'jus-mundi',
          'bnpp',
          'deezer',
        ]"
        :title="$t('brand.customer_logo_banner.default_title')"
      />

      <div
        class="bg-primary-50 text-primary-950 rounded-lg px-8 py-10 md:py-16"
      >
        <brand-how-it-works-banner origin="enterprise" />
      </div>

      <enterprise-page-offers />

      <enterprise-page-personas />

      <brand-session-place-section>
        <template #append>
          <growth-contact-button
            color="dark"
            origin="enterprise"
            origin_page_action="pollen_house_cta"
            size="xl"
          />
        </template>
      </brand-session-place-section>

      <brand-nps-banner />

      <brand-qualiopi-banner />
    </app-page-wrapper>
  </app-page-gradient-background>
</template>

<script lang="ts" setup>
import EnterprisePageHero from "~/pages/enterprise/_includes/components/enterprise-page-hero.vue";
import EnterprisePageOffers from "~/pages/enterprise/_includes/components/enterprise-page-offers.vue";
import EnterprisePagePersonas from "~/pages/enterprise/_includes/components/enterprise-page-personas.vue";

definePageMeta({
  transparentHeader: true,
});

const newHomeEnabled = useFeatureFlag("new_home");
</script>
